<template>
  <div>
    <v-row class="mx-0">
      <v-col cols="12">
        <party-sale-restrictions :party="party" @refresh="$emit('refresh')" />
      </v-col>
      <v-col cols="12" md="6">
        <party-3ds :party="party" @refresh="$emit('refresh')" class="h-full" />
      </v-col>
      <v-col cols="12" md="6">
        <party-antifraud :party="party" @refresh="$emit('refresh')" />
      </v-col>
      <v-col cols="12" md="6">
        <party-restrictions :party="party" @refresh="$emit('refresh')" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PartyAntifraud from "./modules/PartyAntifraud.vue";
import PartyRestrictions from "./modules/PartyRestrictions.vue";
import PartySaleRestrictions from "./modules/PartySaleRestrictions.vue";
import Party3ds from "./modules/Party3ds.vue";

export default {
  components: {
    PartyAntifraud,
    PartyRestrictions,
    PartySaleRestrictions,
    Party3ds,
  },
  props: {
    party: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style></style>
